import { pathologyList } from "../../constants";
import spineZones from "./MarkupPanel/components/spineZones";
import spineSides from "./MarkupPanel/components/spineSides";

export const clone = (
  obj: Record<string | number | symbol, unknown> | unknown[]
) => JSON.parse(JSON.stringify(obj));

export function hexToRgb(
  hex: string
): { r: number; g: number; b: number } | null {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

export function getPathologyColor(
  pathologyName: string,
  region: string,
  rgb?: boolean
): string {
  let color;
  if (Array.isArray(pathologyName)) {
    color = "#8B0000";
  } else {
    color =
      pathologyList[region].find((item) => item.id === pathologyName)?.color ||
      pathologyList[region][0]?.color;
  }

  if (rgb) {
    const rgbObj = hexToRgb(color);
    return rgbObj ? `${rgbObj.r}, ${rgbObj.g}, ${rgbObj.b}` : "0, 0, 0";
  }
  return color;
}

export function getSpineZoneColor(zoneName: string, rgb?: boolean): string {
  let color;
  if (Array.isArray(zoneName)) {
    color = "#8B0000";
  } else {
    color =
      spineZones.find((item) => item.id === zoneName)?.color ||
      spineZones[0]?.color;
  }

  if (rgb) {
    const rgbObj = hexToRgb(color);
    return rgbObj ? `${rgbObj.r}, ${rgbObj.g}, ${rgbObj.b}` : "0, 0, 0";
  }
  return color;
}

export function getSpineSideColor(sideName: string, rgb?: boolean): string {
  let color;
  if (Array.isArray(sideName)) {
    color = "#8B0000";
  } else {
    color =
      spineSides.find((item) => item.value === sideName)?.color ||
      spineSides[0]?.color;
  }

  if (rgb) {
    const rgbObj = hexToRgb(color);
    return rgbObj ? `${rgbObj.r}, ${rgbObj.g}, ${rgbObj.b}` : "0, 0, 0";
  }
  return color;
}

export const size = {
  xsm: "576px",
  sm: "768px",
  md: "992px",
  lg: "1200px",
  xl: "1400px",
};

export const device = {
  mobileS: `max-width: ${size.xsm}`,
  mobileM: `max-width: ${size.sm}`,
  mobileL: `max-width: ${size.md}`,
  tablet: `max-width: ${size.lg}`,
  desktop: `max-width: ${size.xl}`,
  bigDesktop: `min-width: ${size.xl}`,
};
